import { render, staticRenderFns } from "./ScheduleNotificationToggle.vue?vue&type=template&id=49a87630&"
import script from "./ScheduleNotificationToggle.vue?vue&type=script&lang=ts&"
export * from "./ScheduleNotificationToggle.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleNotificationToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports